import {
  type CollectiveGroupResponse,
  rdbV1CollectiveGroupsDetail,
  v1CollectiveGroupsHeadlinesDetail,
} from '@on3/api';
import { withAuthentication } from '@on3/ui-lib/src/hocs/withAuthentication';
import { withValidUrl } from '@on3/ui-lib/src/hocs/withValidUrl';
import { getFulfilledValue, proxyApi } from '@on3/ui-lib/utils/api';
import { getIdFromParam } from '@on3/ui-lib/utils/url';
import type { AxiosError } from 'axios';
import {
  CategoryPage,
  type ICategoryPageProps,
} from 'components/Category/CategoryPage';
import { PageWrapper } from 'components/Layouts/PageWrapper';
import type { GetServerSideProps } from 'next';

interface CollectiveNewsProps extends ICategoryPageProps {
  collective: CollectiveGroupResponse;
}
const CollectiveGroupNewsPage = (props: CollectiveNewsProps) => {
  const collectiveName = props?.collective?.name;
  const title = `${collectiveName} News` || 'NIL News';

  return (
    <PageWrapper {...props} title={`${collectiveName}  News | On3.com`}>
      <CategoryPage {...props} pageTitle={title} />
    </PageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const nilSiteKey = 368;
  const siteData = await withValidUrl.isValid(ctx, nilSiteKey);
  const userData = await withAuthentication.isAuth(ctx);

  try {
    const { collectiveGroup, page = 1 } = ctx.query as {
      collectiveGroup: string;
      page: string;
    };
    const collectiveKey = getIdFromParam(collectiveGroup);

    if (!siteData || !collectiveKey) {
      return {
        notFound: true,
      };
    }

    const params = {
      page: +page,
      key: collectiveKey,
    };

    const [collective, articles] = await Promise.allSettled([
      rdbV1CollectiveGroupsDetail(proxyApi, collectiveKey),
      v1CollectiveGroupsHeadlinesDetail(proxyApi, params),
    ]);

    return {
      props: {
        pageType: 'category',
        siteData,
        userData: userData || {},
        articles: getFulfilledValue(articles),
        collective: getFulfilledValue(collective),
      },
    };
  } catch (error) {
    const err: AxiosError<unknown> = error as AxiosError<unknown>;

    console.log(err.message);

    return { props: {} };
  }
};

export default withValidUrl(CollectiveGroupNewsPage);
